import React from 'react';
import { cn } from '../../lib/utils';

interface BackgroundProps {
  children: React.ReactNode;
  className?: string;
}

const Background: React.FC<BackgroundProps> = ({ children, className }) => {
  return (
    <div className={cn("min-h-screen relative bg-white", className)}>
      {/* Grid overlay */}
      <div className="absolute inset-0 z-[2] bg-[linear-gradient(to_right,#e0e0e0_1px,transparent_1px),linear-gradient(to_bottom,#e0e0e0_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-50" />
      {/* Content container */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};

export default Background; 